import React, { useState, useEffect } from 'react';
import './Login.css';
import ThemeSwitcher from './Components/ThemeSwitcher';

function CharacterList({ characterList = [], onClick, currentTheme, onThemeChange, toggleCreate }) {
    const [selectCharacter, setSelectCharacter] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [showSettings, setShowSettings] = useState(false);

    console.log('CharacterList component - characterList:', characterList);

    useEffect(() => {
        document.documentElement.setAttribute('data-theme', currentTheme);
        localStorage.setItem('theme', currentTheme);
    }, [currentTheme]);

    const handleCharacterSelect = (characterName) => {
        setSelectCharacter(characterName);
    };

    const handleCharacterPlay = (character) => {
        if (typeof character === 'string') {
            onClick("002" + character);
        } else {
            onClick("002" + character.name);
        }
    };

    const handleSearchKeyPress = (e) => {
        if (e.key === 'Enter' && filteredCharacters.length > 0) {
            handleCharacterPlay(filteredCharacters[0]);
        }
    };

    const safeCharacterList = Array.isArray(characterList) ? characterList : [];
    const filteredCharacters = safeCharacterList.filter(character =>
        character && character.name && character.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <>
            <div className="character-container">
                <div className="character-wrapper">
                    <div className="character-header">
                        <div className="account-search">
                            <span className="material-symbols-outlined">search</span>
                            <input
                                type="text"
                                placeholder="Search characters..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                onKeyPress={handleSearchKeyPress}
                                aria-label="Search characters"
                            />
                        </div>
                        <div className="account-settings">
                            <button 
                                className="settings-button"
                                onClick={() => setShowSettings(true)}
                                aria-label="Account settings"
                            >
                                <span className="material-symbols-outlined">settings</span>
                                Settings
                            </button>
                        </div>
                    </div>
                    <div className="table-container">
                        <table>
                            <thead>
                                <tr>
                                    <th className="port-col">Portrait</th>
                                    <th>Character</th>
                                    <th>Level</th>
                                    <th>Class</th>
                                    <th>Race</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredCharacters.map((character) => (
                                    <TableRow
                                        key={character.id || character.name}
                                        character={character}
                                        onClick={handleCharacterPlay}
                                        selectCharacter={selectCharacter}
                                        onSelect={handleCharacterSelect}
                                    />
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="character-actions">
                    <button 
                        className="register"
                        onClick={toggleCreate}
                    >
                        <span className="material-symbols-outlined">add_circle</span>
                        Create Character
                    </button>
                    <button 
                        className={`sign ${!selectCharacter ? 'disabled' : ''}`}
                        disabled={!selectCharacter} 
                        onClick={() => handleCharacterPlay(selectCharacter)}
                    >
                        <span className="material-symbols-outlined">play_circle</span>
                        {selectCharacter ? `Play ${selectCharacter}` : "Select a character"}
                    </button>
                </div>
            </div>
            
            {showSettings && (
                <SettingsModal 
                    onClose={() => setShowSettings(false)}
                    currentTheme={currentTheme}
                />
            )}
            
            <ThemeSwitcher currentTheme={currentTheme} onThemeChange={onThemeChange} />
        </>
    );
}

function TableRow({ character, onClick, selectCharacter, onSelect }) {
    const isSelected = character.name === selectCharacter;
    
    const handleRowClick = () => {
        onSelect(character.name);
    };

    const handleDoubleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick(character);
    };
    
    return (
        <tr 
            className={isSelected ? 'selected' : ''}
            onClick={handleRowClick}
            onDoubleClick={handleDoubleClick}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleRowClick();
                }
            }}
            aria-selected={isSelected}
        >
            <td className="port-col">
                <div className="account-portrait">
                    <img 
                        src={require('./Assets/gfx/' + character.picId + '.webp')} 
                        alt={`${character.name}'s portrait`}
                    />
                </div>
            </td>
            <td>{character.name}</td>
            <td>{character.level}</td>
            <td>{character.clazz}</td>
            <td>{character.race}</td>
            <td>
                <span 
                    className="material-symbols-outlined play-icon" 
                    onClick={(e) => {
                        e.stopPropagation();
                        onClick(character);
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            e.stopPropagation();
                            onClick(character);
                        }
                    }}
                    title="Play Character"
                    role="button"
                    tabIndex={0}
                >
                    play_circle
                </span>
            </td>
        </tr>
    );
}

function SettingsModal({ onClose, currentTheme }) {
    const [activeTab, setActiveTab] = useState('email');
    const [formData, setFormData] = useState({
        email: '',
        emailPassword: '',
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
        deleteCharacterName: '',
        deletePassword: ''
    });

    const handleInputChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle form submission based on activeTab
        switch (activeTab) {
            case 'email':
                console.log('Change email:', formData.email, 'Password:', formData.emailPassword);
                break;
            case 'password':
                console.log('Change password');
                break;
            case 'delete':
                console.log('Delete character');
                break;
            default:
                break;
        }
    };

    return (
        <div className="settings-modal-overlay" onClick={onClose}>
            <div className="settings-modal" onClick={(e) => e.stopPropagation()}>
                <div className="settings-header">
                    <h2>Account Settings</h2>
                    <button className="close-button" onClick={onClose}>
                        <span className="material-symbols-outlined">close</span>
                    </button>
                </div>
                
                <div className="settings-tabs">
                    <button 
                        className={`tab-button ${activeTab === 'email' ? 'active' : ''}`}
                        onClick={() => setActiveTab('email')}
                    >
                        <span className="material-symbols-outlined">email</span>
                        Change Email
                    </button>
                    <button 
                        className={`tab-button ${activeTab === 'password' ? 'active' : ''}`}
                        onClick={() => setActiveTab('password')}
                    >
                        <span className="material-symbols-outlined">lock</span>
                        Change Password
                    </button>
                    <button 
                        className={`tab-button ${activeTab === 'delete' ? 'active' : ''}`}
                        onClick={() => setActiveTab('delete')}
                    >
                        <span className="material-symbols-outlined">delete</span>
                        Delete Character
                    </button>
                </div>

                <form onSubmit={handleSubmit} className="settings-form">
                    <div className="settings-form-content">
                        {activeTab === 'email' && (
                            <>
                                <div className="form-group">
                                    <label htmlFor="new-email">New Email Address</label>
                                    <input
                                        id="new-email"
                                        type="email"
                                        placeholder="Enter new email address"
                                        value={formData.email}
                                        onChange={(e) => handleInputChange('email', e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="email-password">Current Password</label>
                                    <input
                                        id="email-password"
                                        type="password"
                                        placeholder="Enter your current password"
                                        value={formData.emailPassword}
                                        onChange={(e) => handleInputChange('emailPassword', e.target.value)}
                                        required
                                    />
                                </div>
                            </>
                        )}

                        {activeTab === 'password' && (
                            <>
                                <div className="form-group">
                                    <label htmlFor="current-password">Current Password</label>
                                    <input
                                        id="current-password"
                                        type="password"
                                        placeholder="Enter current password"
                                        value={formData.currentPassword}
                                        onChange={(e) => handleInputChange('currentPassword', e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="new-password">New Password</label>
                                    <input
                                        id="new-password"
                                        type="password"
                                        placeholder="Enter new password"
                                        value={formData.newPassword}
                                        onChange={(e) => handleInputChange('newPassword', e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="confirm-password">Confirm New Password</label>
                                    <input
                                        id="confirm-password"
                                        type="password"
                                        placeholder="Confirm new password"
                                        value={formData.confirmPassword}
                                        onChange={(e) => handleInputChange('confirmPassword', e.target.value)}
                                        required
                                    />
                                </div>
                            </>
                        )}

                        {activeTab === 'delete' && (
                            <>
                                <div className="warning-message">
                                    <span className="material-symbols-outlined">warning</span>
                                    <p>This action cannot be undone. Type the character name exactly to confirm deletion.</p>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="delete-character-name">Character Name</label>
                                    <input
                                        id="delete-character-name"
                                        type="text"
                                        placeholder="Type character name exactly"
                                        value={formData.deleteCharacterName}
                                        onChange={(e) => handleInputChange('deleteCharacterName', e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="delete-password">Current Password</label>
                                    <input
                                        id="delete-password"
                                        type="password"
                                        placeholder="Enter your current password"
                                        value={formData.deletePassword}
                                        onChange={(e) => handleInputChange('deletePassword', e.target.value)}
                                        required
                                    />
                                </div>
                            </>
                        )}
                    </div>

                    <div className="settings-actions">
                        <button type="button" className="back" onClick={onClose}>
                            <span className="material-symbols-outlined">close</span>
                            Cancel
                        </button>
                        <button 
                            type="submit" 
                            className={`sign ${activeTab === 'delete' ? 'delete-button' : ''}`}
                            disabled={activeTab === 'delete' && (!formData.deleteCharacterName || !formData.deletePassword)}
                        >
                            <span className="material-symbols-outlined">
                                {activeTab === 'email' ? 'email' : activeTab === 'password' ? 'lock' : 'delete'}
                            </span>
                            {activeTab === 'email' ? 'Update Email' : 
                             activeTab === 'password' ? 'Change Password' : 'Delete Character'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default CharacterList;